<wr-base-dialog header="Profi.Neo Synchronisation"
                status="primary"
                dialogWidth="large"
                [showSubmitButton]="false"
                [showCancelButton]="false">
  <div class="sync-dialog-content">
    <div class="search-row">
      <input type="text"
             nbInput
             fullWidth
             placeholder="Suche nach Objektnummer oder Adresse..."
             [ngModel]="searchText()"
             (ngModelChange)="searchText.set($event)">
      <button nbButton
              ghost
              [status]="showCheckedOnly() ? 'primary' : 'basic'"
              (click)="toggleShowCheckedOnly()"
              nbTooltip="Nur ausgewählte anzeigen">
        <nb-icon pack="eva" [icon]="showCheckedOnly() ? 'eye-off-outline' : 'eye-outline'"></nb-icon>
      </button>
    </div>

    <nb-list class="building-list" nbInfiniteList (bottomThreshold)="loadMore()" [threshold]="50" [throttleTime]="100"
             [nbSpinner]="loading()" nbSpinnerSize="medium" nbSpinnerStatus="primary">
        @for (building of displayedBuildings(); track building.id) {
          <nb-list-item>
            <div class="building-row" (click)="toggleSelection(building)">
              <div class="building-info">
                <span class="building-name">{{ building.baseData.sectionText }}</span>
                <span class="building-details">{{ building.internalNumber }} · {{ building.ownerTenantName }}</span>
              </div>
              <nb-checkbox [checked]="isSelected(building.id)"
                           (checkedChange)="toggleSelection(building)"
                           (click)="$event.stopPropagation()">
              </nb-checkbox>
            </div>
          </nb-list-item>
        }
        @if (displayedBuildings().length === 0 && !loading()) {
          <nb-list-item>
            <div class="no-entries">
              Keine Gebäude gefunden
            </div>
          </nb-list-item>
        }
    </nb-list>

    <div class="dialog-actions">
      <button nbButton status="basic" (click)="cancel()">Zurück</button>
      <button nbButton status="primary" [disabled]="selectedCount() === 0" (click)="sync()">
        Sync ({{ selectedCount() }})
      </button>
    </div>
  </div>
</wr-base-dialog>
